import { useDispatch } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { setRequestQuizPath } from 'redux/style_request_quiz/requestQuiz.slice';
import { PATH } from 'routes/constant';

const RedirectToStyleRequests = (props: { newPath: string }) => {
    const dispatch = useDispatch();

    dispatch(setRequestQuizPath(props?.newPath));

    return <Redirect to={PATH.STYLE_REQUEST_QUIZ} />;
};

export default RedirectToStyleRequests;
